export const documentsCards = {
    documentCard: {
        entity: 'document',
        path: 'document',
        titleBar: { mergeParams: ['name'], new: 'documents.document.form.new.title' },
        cardTitle: {
            title: 'documents.document.form.dropdown.toggle',
            menuItems: [
                { action: 'move', label: 'documents.document.form.move' },
                { action: 'delete', label: 'documents.document.form.delete', confirm: true, modalConfig: 'documentConfirmDelete' }
            ]
        },
        sections: [{
            id: 'document',
            meta: { type: 'form', width: '600px' },
            groups: [
                { type: 'text', id: 'name', label: 'documents.document.form.name', placeholder: 'documents.document.form.name.placeholder', required: true },
                { type: 'select', id: 'fileType', displayField: 'fileTypeName', label: 'documents.document.form.fileType', entity: 'documentType', valueMap: { 'fileType': 'id', 'fileTypeName': 'name' }, options: { withHeaders: false }, required: true },
                { type: 'connect', id: 'folderId', displayField: 'folderName', label: 'documents.document.form.folder', placeholder: 'documents.document.form.folder.placeholder', modalTitle: 'documents.document.form.folder.modal.title', entity: 'folder', valueMap: { 'folderId': 'id', 'folderName': 'name', 'folderPath': 'path' }, options: { withHeaders: false }, required: true },
                { type: 'textarea', id: 'description', label: 'documents.document.form.description', rows: 3 },
                { type: 'fileUpload', id: 'fileUrl', field: 'fileUrl', fileNameField: 'fileName', fileSizeField: 'fileSize', label: 'documents.document.form.file', folder: 'documents', accept: '.pdf,.png,.jpg,.jpeg,.gif,.webp', condition: { field: 'fileType', operator: 'in', value: ['pdf', 'image'] } },
                { type: 'text', id: 'linkUrl', label: 'documents.document.form.linkUrl', placeholder: 'documents.document.form.linkUrl.placeholder', condition: { field: 'fileType', operator: 'equals', value: 'link' } },
                { type: 'chipInput', id: 'tags', label: 'documents.document.form.tags', placeholder: 'documents.document.form.tags.placeholder' }
            ],
            buttons: [
                { type: 'submit', id: 'documentCard.document.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }
            ],
            displaySection: {
                emptyField: 'name',
                columns: [{
                    weight: 1, basis: '100%',
                    elements: [
                        { type: 'field', value: 'name', scale: 'title' },
                        { type: 'field', value: 'fileTypeName', scale: 'normal' },
                        { type: 'field', value: 'folderPath', scale: 'normal' },
                        { type: 'field', value: 'description', scale: 'normal' }
                    ]
                }]
            }
        }]
    },

    documentRichTextCard: {
        entity: 'document',
        path: 'document',
        titleBar: { mergeParams: ['name'], new: 'documents.document.form.new.title' },
        cardTitle: {
            title: 'documents.document.form.dropdown.toggle',
            menuItems: [
                { action: 'move', label: 'documents.document.form.move' },
                { action: 'delete', label: 'documents.document.form.delete', confirm: true, modalConfig: 'documentConfirmDelete' }
            ]
        },
        sections: [{
            id: 'document',
            meta: { type: 'form', width: '800px' },
            groups: [
                { type: 'text', id: 'name', label: 'documents.document.form.name', placeholder: 'documents.document.form.name.placeholder', required: true },
                { type: 'connect', id: 'folderId', displayField: 'folderName', label: 'documents.document.form.folder', placeholder: 'documents.document.form.folder.placeholder', modalTitle: 'documents.document.form.folder.modal.title', entity: 'folder', valueMap: { 'folderId': 'id', 'folderName': 'name', 'folderPath': 'path' }, options: { withHeaders: false }, required: true },
                { type: 'textarea', id: 'description', label: 'documents.document.form.description', rows: 3 },
                { type: 'richtext', id: 'content', label: 'documents.document.form.content', rows: 20 }
            ],
            buttons: [
                { type: 'submit', id: 'documentRichTextCard.document.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }
            ],
            displaySection: {
                emptyField: 'name',
                columns: [{
                    weight: 1, basis: '100%',
                    elements: [
                        { type: 'field', value: 'name', scale: 'title' },
                        { type: 'field', value: 'folderPath', scale: 'normal' },
                        { type: 'field', value: 'description', scale: 'normal' }
                    ]
                }]
            }
        }]
    },

    folderCard: {
        entity: 'folder',
        path: 'folder',
        titleBar: { mergeParams: ['name'], new: 'documents.folder.form.new.title' },
        cardTitle: {
            title: 'documents.folder.form.dropdown.toggle',
            menuItems: [
                { action: 'delete', label: 'documents.folder.form.delete', confirm: true, modalConfig: 'folderConfirmDelete' }
            ]
        },
        sections: [{
            id: 'folder',
            meta: { type: 'form', width: '500px' },
            groups: [
                { type: 'text', id: 'name', label: 'documents.folder.form.name', placeholder: 'documents.folder.form.name.placeholder', required: true },
                { type: 'connect', id: 'parentFolderId', displayField: 'parentFolderName', label: 'documents.folder.form.parentFolder', placeholder: 'documents.folder.form.parentFolder.placeholder', modalTitle: 'documents.folder.form.parentFolder.modal.title', entity: 'folder', valueMap: { 'parentFolderId': 'id', 'parentFolderName': 'name' }, options: { withHeaders: false } },
                { type: 'textarea', id: 'description', label: 'documents.folder.form.description', rows: 3 }
            ],
            buttons: [
                { type: 'submit', id: 'folderCard.folder.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }
            ],
            displaySection: {
                emptyField: 'name',
                columns: [{
                    weight: 1, basis: '100%',
                    elements: [
                        { type: 'field', value: 'name', scale: 'title' },
                        { type: 'field', value: 'path', scale: 'normal' },
                        { type: 'field', value: 'description', scale: 'normal' }
                    ]
                }]
            }
        }]
    },
}
